export default __webpack_public_path__ + "static/iso_17100-d3bad022fd5545cefd72a5f5ceca60eb.webp";